export default __webpack_public_path__ + "static/media/powerSupply.7a85696c.svg";